"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  font-size: 16px;\n  font-family: ", ";\n  background: ", ";\n  color: ", ";\n  height: 49px;\n  padding: 0 16px;\n  overflow: hidden;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.selected {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  .label {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    flex: 1;\n  }\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  font-size: 16px;\n  font-family: ", ";\n  background: ", ";\n  color: ", ";\n  height: 49px;\n  padding: 0 16px;\n  overflow: hidden;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.selected {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.disabled {\n    background: ", ";\n    color: ", ";\n  }\n\n  .label {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    flex: 1;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map